var render, staticRenderFns
import script from "./SalesChart.vue?vue&type=script&lang=js"
export * from "./SalesChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('324a509e')) {
      api.createRecord('324a509e', component.options)
    } else {
      api.reload('324a509e', component.options)
    }
    
  }
}
component.options.__file = "src/view/pages/components/Statistics/SalesChart.vue"
export default component.exports